new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },
  loop: true,
  // slidesPerView: "auto",
  // centeredSlides: true,
  pagination: { el: ".sp-pagination", clickable: true },
  spaceBetween: 20,
});

var thumbsp1 = new Swiper("#thumbs-p", {
  spaceBetween: 5,
  slidesPerView: 6,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper = new Swiper("#swiper-p1", {
  on: {
    slideChange: function (e) {
      $("#sp-color .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  thumbs: {
    swiper: thumbsp1,
  },
  spaceBetween: 20,
});

// 两个部分
var thumbsp2 = new Swiper("#swiper-p2-thumbs", {
  spaceBetween: 7,
  slidesPerView: 3,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper2 = new Swiper("#swiper-p2", {
  on: {
    // slideChange: function (e) {
    //   $("#sp-color .option")
    //     .eq(e.activeIndex)
    //     .addClass("active")
    //     .siblings()
    //     .removeClass("active");
    // },
  },
  thumbs: {
    swiper: thumbsp2,
  },
  spaceBetween: 20,
});
var thumbsp3 = new Swiper("#swiper-p3-thumbs", {
  spaceBetween: 7,
  slidesPerView: 3,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper3 = new Swiper("#swiper-p3", {
  on: {
    // slideChange: function (e) {
    //   $("#sp-color .option")
    //     .eq(e.activeIndex)
    //     .addClass("active")
    //     .siblings()
    //     .removeClass("active");
    // },
  },
  thumbs: {
    swiper: thumbsp3,
  },
  spaceBetween: 20,
});

let spImgList = [
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p1-202407190-p1.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p1-202407190-p2.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p1-202407190-p3.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p1-202407190-p4.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p1-202407190-p5.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p1-202407190-p6.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/ps-202407190-p1-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/ps-202407190-p2-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/ps-202407190-p3-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/ps-202407190-p4-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/ps-202407190-p5-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/ps-202407190-p6-s.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p2-202407190-pp1.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p2-202407190-pp2.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p2-202407190-pp3.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p2-202407190-pp4.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p2-202407190-pp5.png",
  "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/p2-202407190-pp6.png",
];
let spImgList2 = ["https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/202407190-b1.png", "https://cdn.shopifycdn.net/s/files/1/0552/0474/1183/files/202407190-b2.jpg"];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            262 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let sp_price1 = 19.99;
let sp_price2 = 35.98;

function calcTotal(price, num) {
  let result = Number(price) * Number(num);
  return result.toFixed(2);
}
let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let model = $('#sp-model div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == model)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .price-group .price3 span").html(off_font);
}
$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})

$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice()
  }
  changePrice()
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice()
});

$(function () {
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项

    let colorOptions = $("#sp-color .option.active").index();

    swiper.slideTo(colorOptions);
    changePrice()
  });

  // style选项
  // // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");
  //     $(".sp-top-btn span").html("Check out");
  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-top-btn").removeClass("sp-high");
  //     $(".sp-top-btn span").html("Buy now");
  //     $(".sp-header-top .sp-cart").removeClass("on");
  //   }
  // }
  // handleAddToCart(0);

  // 购物车加购动效
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });

  // 双购物部分处理
  let spShopIndex = 0;
  $(".sp-check").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    spShopIndex = $(this).index();
    if (spShopIndex == 0) {
      $(".sp-index1").show();
      $(".sp-index2").hide();
    } else {
      $(".sp-index1").hide();
      $(".sp-index2").show();
    }
  });

  let colorList = ["Gray", "Purple", "Blue", "Black", "Silver", "Dark Blue"];
  let modelList = [
    "iphone15ProMax",
    "iphone15Pro",
    "iphone15",
    "iphone14ProMax",
    "iphone14Pro",
    "iphone14",
    "iphone13ProMax",
    "iphone13Pro",
    "iphone13",
    "iphone12ProMax",
    "iphone12Pro",
    "iphone12",
  ];
  // 模拟select-option
  $(".sp-select").click(function () {
    $(this).siblings(".select-opt").toggle();
  });

  $(".select-opt li").click(function () {
    let _index = $(this).index();
    let _parent = $(this).parent().parent().siblings(".sp-select");
    if (_parent.attr("data-type") == "spColor1") {
      _parent.text(colorList[_index]);
      swiper2.slideTo(_index);
    } else if (_parent.attr("data-type") == "spColor2") {
      _parent.text(colorList[_index]);
      swiper3.slideTo(_index);
    } else {
      _parent.text(modelList[_index]);
    }
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $(".select-opt").hide();
  });


  $(".product-part .cart-btn").click(function () {
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });

    // var img = $(".product-part .p-img");
    var img;
    if (spShopIndex == 0) {
      img = $(".product-part .sp-swiper .swiper-slide-active img");
    } else {
      img = $(".product-part .sp-swiper2 .swiper-slide-active img");
    }

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
    // 另一个
    if (spShopIndex == 1) {
      var img2;

      img2 = $(".product-part #swiper-p3 .swiper-slide-active img");
      var flyer2 = img2[0].cloneNode(true);
      flyer2.classList.add("sp_clone2");

      $(".product-part").append(flyer2);
      $(".sp_clone2").css({
        width: img2[0].width,
        height: img2[0].height,
        position: "fixed",
        top: img2[0].offsetTop,
        left: img2.offset().left,
        "z-index": "99",
      });

      $(".sp_clone2").animate(
        {
          top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    }
  });
});
